module.exports = __webpack_public_path__ + "media/images/flags/gy-a1df57d3d2d8563516bc622a10db086f.svg";